<template>
  <div class="wf-variables-table wf-variables-table--is-loading">
    <div v-for="l in 2" :key="`library-${l}`">
      <div :class="[$style.header]">
        <div :class="[$style.cell]">
          <div class="skeleton-cell" />
        </div>
      </div>
      <div v-for="c in 3" :key="`library-${l}-collection-${c}`" :class="[$style.cell]">
        <div class="skeleton-cell" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.cell {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.header {
  background-color: rgba(0, 0, 0, 0.03);
}
</style>
